import React from "react";
import { Link } from "react-router-dom";
import benefitImg1 from "../../../assets/images/outer/benefit_1.svg";
import benefitImg2 from "../../../assets/images/outer/benefit_2.svg";
import benefitImg3 from "../../../assets/images/outer/benefit_3.svg";
import { _t } from "../../Common/components/InjectIntlContext";
import { Typography } from "antd";
import BenefitCardItem from "./BenefitCardItem";
import { APP_ROUTES } from "../../../system/constants/constantsUrl";

const slides = (_t: any) => [
  {
    title: _t("benefit_1"),
    icon: benefitImg1,
  },
  {
    title: _t("benefit_2"),
    icon: benefitImg2,
  },
  {
    title: _t("benefit_3"),
    icon: benefitImg3,
  },
];

export type ourBenefitsProps = {
  getStarted: () => void;
};

const OurBenefits = () => {
  const benefitCards = slides(_t);
  const benefit = (card, idx) => (
    <li className="benefits-grid__item">
      <BenefitCardItem info={card} key={card.title + idx} />
    </li>
  );

  return (
    <section className="our-benefits custom-section">
      <div className="container">
        <Typography.Title level={2} className="custom-section__title">
          {_t("our_benefits")}
        </Typography.Title>
        <ul className="benefits-grid">{benefitCards.map(benefit)}</ul>
        <div className="get-started">
          <a
            href={_t("dashboard_link_sign_up")}
            target="_blank"
            rel="noreferrer noopener"
            className="btn"
          >
            {_t("sign_up")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default OurBenefits;
